import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import GdsInvitationModel from '~/glm/models/gds/gds-invitation-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import GdsGuest from '~/glm/models/gds/gds-guest-model';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import RsvpCell from '~/glm/components/guest-list/cells/rsvp-cell';
import AnalyticsStore from '~/glm/models/analytics-store';
import styles from './rsvps-cell.scss';

@observer
class RsvpsCell extends Component {
  static propTypes = {
    invitations: PropTypes.arrayOf(PropTypes.instanceOf(GdsInvitationModel)),
    guests: PropTypes.arrayOf(PropTypes.instanceOf(GdsGuest)),
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    displayUninvitedGuests: PropTypes.bool,
    event: PropTypes.instanceOf(GdsEventModel),
    disabled: PropTypes.bool,
    highlightAnimation: PropTypes.bool,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore),
  };

  render() {
    const {
      invitations,
      gdsUiState,
      guests,
      event,
      analyticsStore,
      highlightAnimation = false,
      displayUninvitedGuests = false,
      disabled = false,
    } = this.props;
    const guestObj = {};
    guests.forEach(guest => (guestObj[guest.id] = guest));

    return (
      <td
        className={classNames(
          {
            [styles.disabledRsvpContainer]: disabled,
            [styles.highlightedRsvpContainer]: !disabled && highlightAnimation,
            [styles.rsvpContainer]: !disabled && !highlightAnimation,
          },
          styles.rsvp
        )}
      >
        {displayUninvitedGuests
          ? guests.map(guest => (
              <RsvpCell
                key={`${guest.id}-rsvpcell`}
                gdsInvitation={guest.getInvitationByEvent(event.id)}
                gdsUiState={gdsUiState}
                guest={guest}
                event={event}
                analyticsStore={analyticsStore}
                disabled={disabled}
              />
            ))
          : invitations.map(invitation => (
              <RsvpCell
                key={`${invitation.guestId}-rsvpcell`}
                gdsInvitation={invitation}
                gdsUiState={gdsUiState}
                guest={guestObj[invitation.guestId]}
                analyticsStore={analyticsStore}
                disabled={disabled}
              />
            ))}
      </td>
    );
  }
}

export default RsvpsCell;
